/**
 * Colunas do relatório — fonte Parque locado (TB02112).
 */

import {
  FileText,
  Users,
  Building2,
  Package,
  Hash,
  Tag,
  CalendarDays,
  CalendarCheck,
  MapPin,
  Gauge,
  CircleDot,
} from 'lucide-react';

export const FILTER_EXCLUDED_IDS_PARQUE = [
  'dataInstalacao',
  'dataDesinstalacao',
  'endereco',
  'cicloMensal',
];

export const DEFAULT_VISIBLE_IDS_PARQUE = [
  'contrato',
  'cliente',
  'equipamento',
  'serie',
  'patrimonio',
  'situacao',
  'dataInstalacao',
  'marca',
  'cidade',
  'uf',
  'site',
];

export const GROUP_EXCLUDE_IDS_PARQUE = ['endereco', 'dataInstalacao', 'dataDesinstalacao'];

export const GROUP_ALWAYS_IDS_PARQUE = [
  'grupoEconomico',
  'marca',
  'grupo',
  'subgrupo',
  'cidade',
  'uf',
  'site',
  'bairro',
  'localizacao',
];

export const COLUMNS_CONFIG_PARQUE = [
  { id: 'contrato', label: 'Contrato', icon: FileText },
  { id: 'cliente', label: 'Cliente', icon: Users },
  { id: 'fantasia', label: 'Fantasia', icon: Users },
  { id: 'grupoEconomico', label: 'Grupo Econômico', icon: Building2 },
  { id: 'codEquipamento', label: 'Cód. Equip.', icon: Hash },
  { id: 'equipamento', label: 'Equipamento', icon: Package },
  { id: 'resumoEquipamento', label: 'Resumo equip.', icon: FileText },
  { id: 'marca', label: 'Marca', icon: Tag },
  { id: 'grupo', label: 'Grupo', icon: Tag },
  { id: 'subgrupo', label: 'Subgrupo', icon: Tag },
  { id: 'cicloMensal', label: 'Ciclo mensal', icon: Gauge },
  { id: 'serie', label: 'Série', icon: Hash },
  { id: 'patrimonio', label: 'Patrimônio', icon: Hash },
  { id: 'situacao', label: 'Situação', icon: CircleDot },
  { id: 'dataInstalacao', label: 'Data instalação', icon: CalendarDays },
  { id: 'dataDesinstalacao', label: 'Data desinstalação', icon: CalendarCheck },
  { id: 'endereco', label: 'Endereço', icon: MapPin },
  { id: 'localizacao', label: 'Localização', icon: MapPin },
  { id: 'logradouro', label: 'Logradouro', icon: MapPin },
  { id: 'numero', label: 'Número', icon: Hash },
  { id: 'bairro', label: 'Bairro', icon: MapPin },
  { id: 'cidade', label: 'Cidade', icon: MapPin },
  { id: 'uf', label: 'UF', icon: MapPin },
  { id: 'cep', label: 'CEP', icon: MapPin },
  { id: 'site', label: 'Site', icon: Building2 },
];
